module.exports = __webpack_public_path__ + "static/media/icon_plus_secondary.27c85d55.svg";